/**
 * Búsqueda local de productos (nombre / código / código de barras).
 * Seguro ante campos null/undefined — evita TypeError en filtros UI.
 */

/**
 * @param {object} producto
 * @param {string} termino
 * @returns {boolean}
 */
export function productoCoincideBusqueda(producto, termino) {
  const term = String(termino || '').trim().toLowerCase();
  if (!term) return true;
  if (!producto || typeof producto !== 'object') return false;
  const hay = `${producto.nombre || ''} ${producto.codigo || ''} ${producto.codigo_barras || ''}`.toLowerCase();
  return hay.includes(term);
}

/**
 * @param {Array<object>} productos
 * @param {string} termino
 * @returns {Array<object>}
 */
export function filtrarProductosPorBusqueda(productos, termino) {
  const list = Array.isArray(productos) ? productos : [];
  const term = String(termino || '').trim();
  if (!term) return [];
  return list.filter((p) => productoCoincideBusqueda(p, term));
}
